module.exports = __webpack_public_path__ + "img/icon1.b8007131.gif";